
import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { compose, branch, renderComponent, mapProps, withState, withHandlers } from 'recompose';
import { withPersonSeach } from '../search/person-search.helper';

export const withPersonSelection = compose(
	withPersonSeach,
	branch(
		({ ready }) => !ready,
		renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
	),
	mapProps(({ people, match }) => ({
		person: people.find(person => person.id.toString() === match.params.person_id)
	})),
	withState('imageError', 'setImageError', false),
);

export default {
	withPersonSelection,
};
